import React, { useState, useCallback } from 'react';
import './App.css';
import ErrorBoundary from './components/ErrorBoundary';
import Header from './components/Header';
import Hero from './components/Hero';
import Approach from './components/Approach';
import Flagship from './components/Flagship';
import FeaturedProjects from './components/FeaturedProjects';
import Portfolio from './components/Portfolio';
import Experience from './components/Experience';
import Skills from './components/Skills';
import Contact from './components/Contact';
import Footer from './components/Footer';
import ResumeModal from './components/ResumeModal';

import { ThemeProvider } from './context/ThemeContext';

function App(): React.JSX.Element {
  const [isResumeModalOpen, setIsResumeModalOpen] = useState<boolean>(false);

  const handleOpenResumeModal = useCallback((): void => {
    setIsResumeModalOpen(true);
  }, []);

  const handleCloseResumeModal = useCallback((): void => {
    setIsResumeModalOpen(false);
  }, []);

  return (
    <ThemeProvider>
      <ErrorBoundary>
        <Header onRequestResume={handleOpenResumeModal} />
        <main>
          <Hero onRequestResume={handleOpenResumeModal} />
          <Approach />
          <Flagship />
          <FeaturedProjects />
          <Portfolio />
          <Experience />
          <Skills />
          <Contact onRequestResume={handleOpenResumeModal} />
        </main>
        <Footer />
        <ResumeModal isOpen={isResumeModalOpen} onClose={handleCloseResumeModal} />
      </ErrorBoundary>
    </ThemeProvider>
  );
}

export default App;
